<template>
  <div class="primary--sidebar">
    <logo
      :source="logoSource"
      :name="installationName"
      :account-id="accountId"
    />
    <nav class="menu vertical">
      <primary-nav-item
        v-for="menuItem in menuItems"
        :key="menuItem.toState"
        :icon="menuItem.icon"
        :name="menuItem.label"
        :showAlert="menuItem.showAlert"
        :to="menuItem.toState"
        :is-child-menu-active="menuItem.key === activeMenuItem"
      />
    </nav>
    <div class="menu vertical user-menu">
      <primary-nav-item
        v-if="!isACustomBrandedInstance"
        icon="book-open-globe"
        name="DOCS"
        :open-in-new-page="true"
        :to="helpDocsURL"
      />
      <div class="help-menu-wrapper">
        <woot-button
          color-scheme="secondary"
          variant="clear"
          class="help-icon"
          :class="{ active: showHelpMenu }"
          @click="toggleHelpMenu"
        >
          <img src="/dashboard/images/help-menu/question-icon.svg" alt="" />
        </woot-button>
        <help-menu
          :show="showHelpMenu"
          :toggle-func="toggleHelpMenu"
          @key-shortcut-modal="$emit('key-shortcut-modal')"
        />
      </div>
      <notification-bell @open-notification-panel="openNotificationPanel" />
      <agent-details @toggle-menu="toggleOptions" />
      <options-menu
        :show="showOptionsMenu"
        @toggle-accounts="toggleAccountModal"
        @show-support-chat-window="toggleSupportChatWindow"
        @key-shortcut-modal="$emit('key-shortcut-modal')"
        @close="toggleOptions"
      />
    </div>
  </div>
</template>
<script>
import Logo from './Logo';
import PrimaryNavItem from './PrimaryNavItem';
import OptionsMenu from './OptionsMenu';
import AgentDetails from './AgentDetails';
import NotificationBell from './NotificationBell';
import Constants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import HelpMenu from './HelpMenu.vue';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    OptionsMenu,
    AgentDetails,
    NotificationBell,
    HelpMenu,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      helpDocsURL: Constants.DOCS_URL,
      showOptionsMenu: false,
      showHelpMenu: false,
    };
  },
  mounted() {
    if (!window.location.pathname.includes('/suspended')) {
      // Business Chat Website Widget
      const BASE_URL = 'https://chat.bevatel.com';
      const g = document.createElement('script');
      const s = document.getElementsByTagName('script')[0];
      g.src = BASE_URL + '/packs/js/sdk.js';
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = () => {
        window.socialAppSDK.run({
          websiteToken: 'qwKvmoVSU6bVHdpizBub8XQj',
          baseUrl: BASE_URL,
        });
      };
    }
  },
  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    },
    toggleSupportChatWindow() {
      window.$socialApp.toggle();
    },
    openNotificationPanel() {
      this.$emit('open-notification-panel');
    },
    toggleHelpMenu() {
      this.showHelpMenu = !this.showHelpMenu;
      window.$socialApp.toggleBubbleVisibility('hide');
    },
  },
};
</script>
<style lang="scss" scoped>
.primary--sidebar {
  display: flex;
  flex-direction: column;
  width: var(--space-jumbo);
  // border-right: 1px solid var(--s-50);
  box-sizing: content-box;
  height: 100%;
  flex-shrink: 0;
}

.menu {
  align-items: center;
  margin-top: var(--space-medium);
}

.user-menu {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  margin-bottom: var(--space-normal);
}

.help-menu-wrapper {
  .help-icon {
    border-radius: var(--border-radius-large);
    border: 1px solid transparent;
    margin: var(--space-small) 0;
    &:hover,
    &.active {
      background: rgba(#000000, 0.4) !important;
      color: var(--w-200) !important;
    }
  }
  &::v-deep {
    .help-menu {
      left: calc(var(--space-slab) + 36px);
      bottom: calc(var(--space-larger) + 82px);
      width: 165px;
      .menu {
        margin-top: 0;
        gap: 6px;
        .help-link {
          padding: 8px 4px;
          border-radius: 6px;
          align-items: center;
          gap: 6px;
          color: var(--b-400);
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
